import React, { useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import image from "../../image/personal/personalimageforhomewhite.png";
import emailjs from "@emailjs/browser";
import "./Contact.css";

const Contact = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);

  const sendMessage = (e) => {
    e.preventDefault();
    setIsSending(true); // Disable button and show "Sending..."

    emailjs
      .send(
        "service_m0jlbli", // Replace with your EmailJS Service ID
        "template_k12egac", // Replace with your EmailJS Template ID
        {
          from_name: form.current.user_name.value,
          from_phone: form.current.user_phone.value,
          message: form.current.message.value,
        },
        "Oyn_3TZJY1lCv82qo" // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log("Message sent successfully:", result.text);
          alert("Message sent successfully!");
          form.current.reset(); // Clear the form fields
        },
        (error) => {
          console.error("Failed to send message:", error.text);
          alert("Failed to send the message. Please try again.");
        }
      )
      .finally(() => {
        setIsSending(false); // Enable the button again
      });
  };

  return (
    <Container className="">
      <Row className="">
        <Col sm={12} md={6} className="">
          <img
            src={image}
            className="img-fluid p-5"
            style={{ marginTop: "-40px" }}
            alt=""
          />
        </Col>
        <Col sm={12} md={6} style={{ marginTop: "40px" }}>
          <h5 className="fw-bolder mt-3 text-warning">CONTACT ME</h5>
          <h1 className="fw-bolder my-4">Get in touch with me today.</h1>
          <Form ref={form} onSubmit={sendMessage}>
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your Name"
                name="user_name"
                className="border border-dark rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPhone">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter your Phone Number"
                name="user_phone"
                className="border border-dark rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Your Message"
                name="message"
                className="border border-dark rounded"
                rows={5}
                required
              />
            </Form.Group>
            <Button
              variant="warning"
              type="submit"
              disabled={isSending}
              className="w-100"
            >
              {isSending ? "Sending..." : "Send Message"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
